import classNames from 'classnames';

import Image from 'components/shared/image';
import VideoPlayer from 'components/shared/video/video';

import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import renderInlineItalic from 'lib/utils/renderInlineItalic';
import Icon from 'components/shared/icon';
import useIsMobiles from 'hooks/utils/useIsMobile';
import styles from './dualBanner.module.scss';

const DualBanner = ({ data, locale }) => {
  const { banners, anchorId } = data || {};
  const isMobile = useIsMobiles();

  return (
    <section id={anchorId} className={styles.wrapper}>
      {banners.map(banner => {
        const { media, link, text, textColor, textColorMobile } = banner || {};
        let iconFill;
        if (isMobile) {
          iconFill = textColorMobile || textColor;
        } else {
          iconFill = textColor || textColorMobile;
        }
        return (
          <div
            key={banner.id}
            className={styles.banner}
            style={{
              '--text-color': textColor === 'White' ? '#FFFFFF' : '#000000',
              '--text-color-mobile': textColorMobile === 'White' ? '#FFFFFF' : '#000000',
            }}
          >
            <div className={styles.mediaContainer}>
              {media?.type === 'Video' && media?.video ? (
                <VideoPlayer
                  className={classNames(styles.media)}
                  thumbnail={media?.thumbnail}
                  source={media.video}
                  sourceDesktop={media.videoDesktop}
                  autoPlay
                  controls={false}
                  forceKeepPlaying
                />
              ) : (
                <Image
                  src={media.image}
                  layout="fill"
                  className={styles.media}
                  loading="eager"
                  priority
                />
              )}
            </div>
            <SiteLink
              className={styles.content}
              aria-label={link?.title}
              href={addLocaleToHref(link?.slug, locale)}
            >
              <span className={styles.bannerText}>
                <span className={styles.text}>{renderInlineItalic(text)}</span>
                <span className={styles.readMore}>
                  <span>{link?.title}</span>
                  <Icon
                    type="arrow"
                    className={styles.icon}
                    fill={iconFill === 'White' ? '#FFFFFF' : '#000000'}
                  />
                </span>
              </span>
            </SiteLink>
          </div>
        );
      })}
    </section>
  );
};

export default DualBanner;
